import React, { Component,useEffect,useState,useRef } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable,{defaultThemes} from 'react-data-table-component';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HTMLParserComponent from "../HTMLParserComponent.js"

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import '../preloading.css';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";




import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const OfficeShift = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	// function getDate() {
	// 	const today = new Date();
	// 	const month = today.getMonth() + 1;
	// 	const year = today.getFullYear();
	// 	const date = today.getDate();
	// 	return `${year}-${month}-${date}`;
	//   }

	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        start_date: today,
        department:"",
    })



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
	const [attnlist, setattnlist]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);

	const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

    
    }

    const [shiftcode,setShiftCodeValue]= useState("");
	const [officeshift,setOfficeShift]= useState([]);

	const handleShift = (event) => {
	const value = event.target.value;
	setShiftCodeValue(value);

	
  };

  const [toggle,setToggle]=useState(false);


		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		let filteredItems = records.filter((item) =>
			`${item.shift_name.toLowerCase()}${item.shift_code.toLowerCase()}`.includes(searchTerm.toLowerCase())
		 
		);
		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
		const sortedItems = sortData(filteredItems);
		const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		// const paginate = (pageNumber) => setCurrentPage(pageNumber);
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	






      const handleDepartment = async () => {
	  
        axios.get(API_BASE_URL +'/showdepartment/', { headers : {
               'Content-Type': 'application/json',
               //'Authorization': 'Bearer 154|DKlDECT0m8FjNaqkz80nCzrt5ziZ8kW2XsaIzEkj260b0b39'
       }})
        .then(res1 => setdataval(res1.data))
        .catch(err => console.log(err))
       };
  
  
       useEffect(() => {
        handleDepartment();
      }, []);






const handleSubmit = async (e) => {
    e.preventDefault();
	setLoading(true);

	// alert(user.start_date);
	// alert(user.department);
    try {
      const response = await axios.post(API_BASE_URL +'/attendancelist',
		{ attendance_date: user.start_date, dept_id: user.department }, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
console.log(response.data.shiftattendance);
      setRecords(response.data.shiftattendance); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(()=> {
	axios.get(API_BASE_URL +'/office_shift_list', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

    // .then(response =>console.log(response.data.office_shift_list))
	 .then(response => setRecords(response.data.office_shift_list))
	.catch(err => console.log(err));
},[])




	const handleUpdateApprovePermission = async (user_id,shift_date,attn_history) => {

			// console.log('hi');

			// alert(user_id);
			// alert(shift_date);

			// e.preventDefault();

			// console.log(user);
			// setError(null);
			// setLoading(true);
			// e.preventDefault();
			//console.log(user);

				axios.post(API_BASE_URL + '/update_approve_permission', { user_id: user_id, shift_date: shift_date,attn_history: attn_history}, {

			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
			}).then(response => {

				


			var status = response.data.status;

			if (status=='success')
			{
			toast.success(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} 
			else if (status=='error')
			{
			toast.error(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			

			}
			}).catch(error => {

			// console.log(error);
			// console.log(error.response.data.message);
			toast.error(error.response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});

			});
			};




			const handleUpdateRejectPermission = async (user_id,shift_date,attn_history) => {

			// console.log('hi');

			// alert(user_id);
			// alert(shift_date);

			// e.preventDefault();

			// console.log(user);
			// setError(null);
			// setLoading(true);
			// e.preventDefault();
			//console.log(user);

				axios.post(API_BASE_URL + '/update_reject_permission', { user_id: user_id, shift_date: shift_date,attn_history: attn_history}, {

			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
			}).then(response => {

				


			var status = response.data.status;

			if (status=='success')
			{
			toast.success(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} 
			else if (status=='error')
			{
			toast.error(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			

			}
			}).catch(error => {

			// console.log(error);
			// console.log(error.response.data.message);
			toast.error(error.response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});

			});
			};


	const emptyUser={
	shift_code: '',
    attendance_date: '',
    clock_in_date: '',
    clock_in: '',
    clock_out_date: '',
	clock_out: '',
	employee_id:'',
	user_id:'',
	old_clock_in_date: '',
	old_clock_in: '',
	old_clock_out_date: '',
	old_clock_out: '',
	old_shift_code: '',
	attendance_history:'',
	}



const [modalData, setModalData] = useState({
    shift_code: '',
    attendance_date: '',
    clock_in_date: '',
    clock_in: '',
    clock_out_date: '',
	clock_out: '',
	employee_id:'',
	user_id:'',
	old_clock_in_date: '',
	old_clock_in: '',
	old_clock_out_date: '',
	old_clock_out: '',
	old_shift_code: '',
	attendance_history:'',
});

const handelModalInput = (e) => {
    const { name, value } = e.target;
    setModalData({ ...modalData, [name]: value });
};

	

	const handleDecision = async (action, exchange_id) => {
	const confirmMessage =
		action === "approve"
			? "Are you sure you want to approve this shift exchange?"
			: "Are you sure you want to reject this shift exchange?";

	if (!window.confirm(confirmMessage)) return;

	const endpoint =
		action === "approve" ? "/approveShiftExchange" : "/rejectShiftExchange";

	try {
		const response = await axios.get(API_BASE_URL + endpoint+'/'+exchange_id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		});

		if (response.data.status === "success") {
			toast.success(response.data.result, {
				position: "bottom-right",
				autoClose: 5000,
				theme: "colored",
			});
			setTimeout(() => window.location.reload(), 1000);
		} else {
			toast.error(response.data.result, {
				position: "bottom-right",
				autoClose: 5000,
				theme: "colored",
			});
		}
	} catch (error) {
		toast.error(error.response?.data?.result || "An error occurred", {
			position: "bottom-right",
			autoClose: 5000,
			theme: "colored",
		});
	}
};



	const handleEditSubmit = (e) => {

		e.preventDefault();

		console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/update_shift_and_attendance', {shift_date : modalData.attendance_date, shift_code: modalData.shift_code, clock_in_date: modalData.clock_in_date,clock_in: modalData.clock_in,clock_out_date: modalData.clock_out_date,clock_out : modalData.clock_out, employee_id: modalData.employee_id,user_id: modalData.user_id,old_clock_in_date: modalData.old_clock_in_date,old_clock_in: modalData.old_clock_in,old_clock_out_date: modalData.old_clock_out_date,
	old_clock_out: modalData.old_clock_out,
	old_shift_code: modalData.old_shift_code,attn_history: modalData.attendance_history }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 'success') {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};

const daysList = [
  "monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"
];


const [showForm, setShowForm] = useState(false);
  const formRef = useRef(null);

  const [shiftData, setShiftData] = useState({
    company_id: "",
    shift_name: "",
    shift_code: "",
    days: daysList.reduce((acc, day) => {
      acc[day] = { in: "", out: "", hours: "" };
      return acc;
    }, {})
  });


   const handleTimeChange = (day, type, value) => {
    const updatedDay = {
      ...shiftData.days[day],
      [type]: value
    };

    let shiftHour = "";
    if (updatedDay.in && updatedDay.out) {
      const [inH, inM] = updatedDay.in.split(":").map(Number);
      const [outH, outM] = updatedDay.out.split(":").map(Number);
      let totalMinutes = (outH * 60 + outM) - (inH * 60 + inM);
      if (totalMinutes < 0) totalMinutes += 1440;
      const h = Math.floor(totalMinutes / 60);
      const m = totalMinutes % 60;
      shiftHour = `${h.toString().padStart(1, "0")}`;
    }

    setShiftData((prev) => ({
      ...prev,
      days: {
        ...prev.days,
        [day]: {
          ...updatedDay,
          hours: shiftHour
        }
      }
    }));
};


  const clearDay = (day) => {
    setShiftData((prev) => ({
      ...prev,
      days: {
        ...prev.days,
        [day]: { in: "", out: "", hours: "" }
      }
    }));
  };

   const handleToggleForm = () => {
    setShowForm(true);
    // setTimeout(() => {
    //   formRef.current?.scrollIntoView({ behavior: "smooth" });
    // }, 100); // delay to ensure form renders before scroll
  };

    //console.log("Submitted:", shiftData);


 const handleOfficeSubmit = async (e) => {
  e.preventDefault();

  
 console.log("Submitted:", shiftData);


  try {
    const response = await axios.post(`${API_BASE_URL}/addOfficeShift`, shiftData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "application/json",
      },
    });

    if (response.data.success) {
      toast.success("Shift created successfully",{position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored"});

	  	const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

      setToggle(false);
      // Reset form
      setShiftData({
        company_id: "",
        shift_name: "",
        shift_code: "",
        days: daysList.reduce((acc, day) => {
          acc[day] = { in: "", out: "", hours: "" };
          return acc;
        }, {}),
      });

      // Reload shift list
      const res = await axios.get(`${API_BASE_URL}/office_shift_list`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
      setRecords(res.data.office_shift_list);
    } else {
      toast.error(response.data.message || "Failed to save shift");
    }
  } catch (err) {
    toast.error(err.response?.data?.message || "Submission error",{position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored"});
  }
};


useEffect(() => {
  if (localStorage.getItem("shiftSuccess") === "true") {
    toast.success("Shift created successfully");
    localStorage.removeItem("shiftSuccess"); 
  }
}, []);


const handleUpdate = async (office_shift_id) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/read_office_shift/${office_shift_id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    });

    const shift = res.data.read_office_shift_info;

    const updatedDays = {};
    daysList.forEach(day => {
      const [start = '', end = '', hours = ''] = (shift[day] || "").split(" ");
      updatedDays[day] = { in: start, out: end, hours };
    });

    setShiftData({
      office_shift_id,
      company_id: shift.company_id || "0",
      shift_name: shift.shift_name || "",
      shift_code: shift.shift_code || "",
      days: updatedDays
    });

    // Show modal
    setTimeout(() => window.$('#editShiftModal').modal('show'), 100);
  } catch (err) {
    toast.error("Failed to load shift");
    console.error(err);
  }
};



const handleOfficeShiftUpdate = async (e) => {
  e.preventDefault();

//   console.log(shiftData.office_shift_id);

//   console.log(shiftData);
//   console.log(`Bearer ${localStorage.getItem("authToken")}`);

  try {
    const response = await axios.put(`${API_BASE_URL}/updateOfficeShift/${shiftData.office_shift_id}`, shiftData, {
     headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`
	  }
    });

    if (response.data.success) {
      toast.success("Shift updated successfully",{
  position: "bottom-right"
});
      window.$('#editShiftModal').modal('hide');

      // Refresh
      const res = await axios.get(`${API_BASE_URL}/office_shift_list`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
      setRecords(res.data.office_shift_list);
    } else {
      toast.error(response.data.message);
    }
  } catch (err) {
    toast.error(err.response?.data?.message,{position: "bottom-right"});
    console.error(err);
  }
};





const columns = [
  { label: "Shift Name", key: "shift_name", sortable: true },
  { label: "Shift Code", key: "shift_code", sortable: true },
  { label: "Monday", key: "monday", sortable: true },
  { label: "Tuesday", key: "tuesday", sortable: true },
  { label: "Wednesday", key: "wednesday", sortable: true },
  { label: "Thursday", key: "thursday", sortable: true },
  { label: "Friday", key: "friday", sortable: true },
  { label: "Saturday", key: "saturday", sortable: true },
  { label: "Sunday", key: "sunday", sortable: true }
];



	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

						<ToastContainer/>
							

						</div>


						
					</div>


                    <div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">

                                 <div className="container mt-4">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
								<button style={{width:'100px',float: 'right',margin: '10px 35px 15px 10px'}}
										type="button"
										className="btn btn-primary"
										onClick={()=>setToggle(!toggle)}
									>
										<i className="fe fe-plus mr-2" />
										Add
									</button>

                                    </div>
                                    </div>



 {toggle && (
        <form className="card p-4" ref={formRef} onSubmit={handleOfficeSubmit}>
          {/* Company, Shift Name, Shift Code */}
         
			<div class="row">
            <div className="col-md-2">
              <label>Company</label>
			  </div>
			  <div className="col-md-4">
              <select className="form-control" value={shiftData.company_id}
                onChange={(e) => setShiftData({ ...shiftData, company_id: e.target.value })}>
               <option value="ALL"></option>
			<option value="0">Annai Arul Hospital</option>
              </select>
            </div>
			</div>
			<div class="row">
			<div className="col-md-2">
              <label>Shift Name</label>
			  </div>
			  <div className="col-md-4">
              <input type="text" className="form-control" value={shiftData.shift_name}
                onChange={(e) => setShiftData({ ...shiftData, shift_name: e.target.value })} />
            </div>
			</div>
			<div class="row">
            <div className="col-md-2">
              <label>Shift Code</label>
			  </div>
			  <div className="col-md-4">
              <input type="text" className="form-control" value={shiftData.shift_code}
                onChange={(e) => setShiftData({ ...shiftData, shift_code: e.target.value })} />
            </div>
          </div>
		

          {/* Daily Input Rows */}
          {daysList.map((day) => (
            <div className="row align-items-center" key={day}>
              <label className="col-sm-2 col-form-label text-capitalize">{day}</label>
              <div className="col-sm-3">

				
                <input
                  type="time"
                  className="form-control"
                  value={shiftData.days[day].in}
                  onChange={(e) => handleTimeChange(day, "in", e.target.value)}
                />
              </div>
              <div className="col-sm-3">
                <input
                  type="time"
                  className="form-control"
                  value={shiftData.days[day].out}
                  onChange={(e) => handleTimeChange(day, "out", e.target.value)}
                />
              </div>
              <div className="col-sm-2">
                <input
                  type="text"
                  className="form-control"
                  value={shiftData.days[day].hours}
                  readOnly
                />
              </div>
              <div className="col-sm-2">
                <button type="button" className="btn btn-danger btn-sm" onClick={() => clearDay(day)}>
                  Clear
                </button>
              </div>
            </div>
          ))}

          <div className="text-end mt-3">
            <button type="submit" className="btn btn-success">Save</button>
          </div>
        </form>
      )}
    

                                    

							

							

							
								
								


</div>
                            </div>
                        </div>
                    </div>





<div className="modal fade" id="editShiftModal" tabIndex="-1" role="dialog">
  <div className="modal-dialog modal-lg" role="document">
    <div className="modal-content">
		
     <form onSubmit={handleOfficeShiftUpdate}>
        <div className="modal-header">
          <h5 className="modal-title">Edit Office Shift</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="modal-body">
          {/* Company, Shift Name, Shift Code */}
          <div class="row">
            <div className="col-md-2">
              <label>Company</label>
			  </div>
			  <div className="col-md-4">
              <select className="form-control" value={shiftData.company_id}
                onChange={(e) => setShiftData({ ...shiftData, company_id: e.target.value })}>
               <option value="ALL"></option>
			<option value="1">Annai Arul Hospital</option>
              </select>
            </div>
			</div>
			<div class="row">
			<div className="col-md-2">
              <label>Shift Name</label>
			  </div>
			  <div className="col-md-4">
              <input type="text" className="form-control" value={shiftData.shift_name}
                onChange={(e) => setShiftData({ ...shiftData, shift_name: e.target.value })} />
            </div>
			</div>
			<div class="row">
            <div className="col-md-2">
              <label>Shift Code</label>
			  </div>
			  <div className="col-md-4">
              <input type="text" className="form-control" value={shiftData.shift_code}
                onChange={(e) => setShiftData({ ...shiftData, shift_code: e.target.value })} />
            </div>
          </div>

		 


          {daysList.map((day) => (
            <div className="form-row align-items-center mb-2" key={day}>
              <div className="col-md-2 text-capitalize">{day}</div>
              <div className="col-md-3">
                <input type="time" className="form-control" value={shiftData.days[day].in} onChange={(e) => handleTimeChange(day, "in", e.target.value)} />
              </div>
              <div className="col-md-3">
                <input type="time" className="form-control" value={shiftData.days[day].out} onChange={(e) => handleTimeChange(day, "out", e.target.value)} />
              </div>
              <div className="col-md-2">
                <input type="text" className="form-control" value={shiftData.days[day].hours} readOnly />
              </div>
              <div className="col-md-2">
                <button type="button" className="btn btn-sm btn-danger" onClick={() => clearDay(day)}>Clear</button>
              </div>
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <button type="submit" className="btn btn-success">Update</button>
        </div>
      </form>
    </div>
  </div>
</div>









					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">

										<div className="card-header">
											<h3 className="card-title" style={{color:'#e96827'}}>List All Office Shift</h3>
											<div className="card-options">
												<form>
													<div className="input-group">
													<EntriesSelector 
														setEntriesPerPage={setEntriesPerPage}
														setCurrentPage={setCurrentPage}
													/>
													
														 <input
															type="text"
															className="form-control form-control-sm"
															placeholder="Search"
															value={searchTerm}
															onChange={e => {
																setSearchTerm(e.target.value);
																setCurrentPage(1);
																}} style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }} 
														/>
													</div>
												</form>
											</div>
										</div>


{loading && (
											<div className="card-body">
											<div class="d-flex justify-content-center">
       <div class="spinner"></div>
	   </div>
	   </div>
      )}

{!loading && (
										<div className="card-body">
										
											<div className="table-responsive">
		

    
      
			<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
                                                            <th>Option</th>
                                                            {columns.map((col) => (
      <th
        key={col.key}
        onClick={col.sortable ? () => handleSort(col.key) : null}
        style={{ cursor: col.sortable ? "pointer" : "default" }}
      >
        {col.label}
         {col.sortable && (
      sortConfig.key === col.key
        ? (sortConfig.direction === "asc" ? " ▲" : " ▼")
        : " ⇅"   // <-- DEFAULT SORT ICON
    )}
		  </th>
    ))}
															
															
															
														</tr>
													</thead>
													<tbody>
														{/* {console.log(records)} */}
													{records.length > 0 ? (
															filteredData.map((record) => {

                                                                let status;

                                                           
                                                                    	
															return(
															<tr key={record.incharge_info}>
																<td>
																	<button
																		type="button" onClick={() =>{ handleUpdate(record.office_shift_id);setModalData(emptyUser)}}
																		className="btn btn-primary"
																		data-toggle="modal"
																		data-target="#editShiftModal"
																		>
																	<i className="fa fa-edit" />
																	</button>

																</td>
																<td>{ReactHtmlParser(record.shift_name)}</td>
																<td>{record.shift_code}</td>
																<td>{ReactHtmlParser(record.monday)}</td>
																<td>{ReactHtmlParser(record.tuesday)}</td>
                                                                <td>{ReactHtmlParser(record.wednesday)}</td>
                                                                <td>{ReactHtmlParser(record.thursday)}</td>
                                                                <td>{ReactHtmlParser(record.friday)}</td>
                                                                <td>{ReactHtmlParser(record.saturday)}</td>
                                                                <td>{ReactHtmlParser(record.sunday)}</td>
                                                              
																

															</tr>
															)
})
														) : (
															<tr>
															<td colSpan="6" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
															</tr>
														)}

											
													</tbody>
												</table>
											</div>
										
			<Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
								

										</div> 
)
}
									</div>
								</div>
	
							
							</div>
						</div>
					</div>

				</div>
			</div> 

										
			


			
			


			

		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(OfficeShift);